export default __webpack_public_path__ + "static/media/1337.b766dbae.png";